import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = defineStore('ui', () => {
  const loading = ref(false)
  const errorMessage = ref<string | null>(null)
  const successMessage = ref<string | null>(null)

  const setLoading = (value: boolean) => {
    loading.value = value
  }

  const showError = (message: string) => {
    errorMessage.value = message
    setTimeout(() => { errorMessage.value = null }, 5000)
  }

  const showSuccess = (message: string) => {
    successMessage.value = message
    setTimeout(() => { successMessage.value = null }, 3000)
  }

  const clearMessages = () => {
    errorMessage.value = null
    successMessage.value = null
  }

  return { loading, errorMessage, successMessage, setLoading, showError, showSuccess, clearMessages }
})
